export const Config = {
  backendUrl: process.env.BACKEND_URL || window.location.protocol + '//' + window.location.host + '/backend-licenseServer/',
  version: '1.0.0'
};
